module.exports = __webpack_public_path__ + "static/morphing-c9e51ae57536eb7c1317655e0de6f41a.webm";